import Slider from 'react-slick/lib/slider';
import {useCallback, useEffect, useRef, useState} from 'react';
import Image from 'next/image';
import {defaultThemeImagePaths, priceHelper} from '@helpers/config-master.mjs';

const settings = {
  infinite: true,
  autoplay: false,
  slidesToShow: 1,
  speed: 100,
  autoplaySpeed: 2000,
  arrows: false,
  dots: true,
  touchThreshold: 500,
  className: 'center-product',
  responsive: [
    {
      breakpoint: 300,
      settings: {
        centerPadding: '0px'
      }
    },
    {
      breakpoint: 580,
      settings: {
        centerPadding: '30px'
      }
    },
    {
      breakpoint: 900,
      settings: {
        centerPadding: '60px'
      }
    }
  ]
};

export const MainImageAndGallerySliderMobile = ({
                                                  selectedVariant,
                                                  sku,
                                                  productImages,
                                                  setIsOpen
                                                }) => {
  const slickRef = useRef(undefined);
  const slickZoomRef = useRef(undefined);
  const [swiped, setSwiped] = useState(false);
  const [sizes, setSizes] = useState('100vw'); // Default to 100vw for server-side rendering

  const mobileProductImageSaleOverlay = defaultThemeImagePaths?.mobileProductImageSaleOverlay;

  const productTitle = selectedVariant?.siteName ?? selectedVariant?.productTitle;

  useEffect(() => {
    slickRef?.current?.slickGoTo(0);
  }, [selectedVariant]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const updateSizes = () => {
        const width = Math.round(Math.min(window.innerWidth, (window.innerHeight / 1200) * 1200));
        setSizes(`${Math.ceil((width / window.innerWidth) * 100)}vw`);
      };

      updateSizes();
      window.addEventListener('resize', updateSizes);
      return () => window.removeEventListener('resize', updateSizes);
    }
  }, []);

  const handleOnItemClick = useCallback(
    (e) => {
      if (swiped) {
        e.stopPropagation();
        e.preventDefault();
        setSwiped(false);
      }
    },
    [swiped]
  );

  const handleOnClick = useCallback(() => {
    setIsOpen(true);
  });

  if (!productImages?.length) return null;

  return (
    <div className='px-2 product-image-gallery-border aspect-[1.3333]' tabIndex='-1'>
      <Slider ref={slickRef} {...settings}>
        {productImages &&
          productImages.map((image, index) => {
            const imageSrcUrl = image?.url;

            return (
              <div
                onClickCapture={handleOnItemClick}
                className='relative'
                key={`image-mobile-${index}`}
                onClick={() => {
                  console.log(' >> Click Mobile Product Page Image');
                  handleOnClick();
                }}>
                <div className='slick-image-wrapper'>
                  <Image
                    alt={`${productTitle} #${index + 1}`}
                    src={imageSrcUrl}
                    width={1200}
                    height={1200}
                    className='w-full h-full aspect-square px-1 object-full'
                    style={{
                      objectFit: 'cover',
                      objectPosition: 'center'
                    }}
                    quality='80'
                    priority={index < 2}
                    sizes={sizes}
                  />

                  {priceHelper?.saleEnabledFor() && (
                    <div className='absolute z-10 top-3 right-0.5 w-3/4 h-3/4 pointer-events-none'>
                      {mobileProductImageSaleOverlay && (
                        <Image
                          src={mobileProductImageSaleOverlay}
                          alt='Sale Info Overlay'
                          priority
                          style={{objectFit: 'fill'}}
                          width={600}
                          height={600}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </Slider>
    </div>
  );
};
